// Module
var code = `<ex-mono-occurrence-ecran formulaire="vm.formulaireRce"> <ex-mono-occurrence-ecran-bas> <ex-card-multi-advanced ex-bloc="tcn" lbl-titre="LBL_BLC_TCN" multi-occurrence-options="vm.tcnMultiOccurrenceOptions" opened="true"> </ex-card-multi-advanced> </ex-mono-occurrence-ecran-bas> </ex-mono-occurrence-ecran>`;
// Exports
module.exports = code;